<template lang="pug">
  vm-prompt( vm-size="medium" @vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteCustomerConfirm(form)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(autofocus :placeholder='$t("customers.tradename_placeholder")' :danger="!$v.form.tradename" :danger-text="'Tradename is required'" v-model="form.tradename" :label='$t("customers.tradename")')
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.contact_placeholder")' v-model="form.contact" :label='$t("customers.contact")')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.phone_placeholder")' v-model="form.phone" :label='$t("customers.phone")' required)
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.email_placeholder")' v-model="form.email" :label='$t("customers.email")' required)
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.address_placeholder")'  v-model="form.address" :label='$t("customers.address")' required)
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.state_placeholder")' v-model="form.state" :label='$t("customers.state")' required)
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.city_placeholder")' v-model="form.city" :label='$t("customers.city")')
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.country_placeholder")' v-model="form.country" :label='$t("customers.country")')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.zip_code_placeholder")' v-model="form.zip_code" :label='$t("customers.zip_code")' required)
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.rfc_placeholder")' v-model="form.rfc" :label='$t("customers.rfc")' required)
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-input(:placeholder='$t("customers.payment_terms_placeholder")' v-model="form.payment_terms" :label='$t("customers.payment_terms")' required :disabled='!$auth.check("Admin")')
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-select(:placeholder='$t("customers.contact_status_select")' v-model="form.contact_status" :label='$t("customers.contact_status")')
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in contactCatalog")
      vm-col(vm-justify="center", vm-align="center", vm-w=6)
        b-form-group
          vm-select(:placeholder='$t("customers.mention_select")' v-model="form.mention_id" :label='$t("customers.mention")')
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in mentionCatalog")
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Customers')

export default {
  name: 'ModalCustomers',
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  validations: {
    form: {
      tradename: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'customersCatalog',
      'contactCatalog',
      'mentionCatalog'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('customers.add') : this.$t('customers.edit')
    }
  },
  async created () {
    this.getCatalog()
    this.getContactCatalog()
    this.getMentionCatalog()
  },
  methods: {
    ...mapActions([
      'addCustomer',
      'editCustomer',
      'deleteCustomer',
      'setModalVisible',
      'loadCatalog',
      'getContactCatalog',
      'getMentionCatalog'
    ]),
    saveRecord () {
      this.isAdd ? this.addCustomer(this.form) : this.editCustomer(this.form)
    },
    async deleteCustomerConfirm (customer) {
      let t = this
      this.auxDeleteCustomer = () => {
        t.deleteCustomer(customer)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(customer.contact) }),
        accept: this.auxDeleteCustomer
      })
    },
    async getCatalog () {
      Object.keys(this.customersCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=*${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    close () {
      this.setModalVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
.vm-col{
  padding: 0px 10px;
}
</style>
